export default __webpack_public_path__ + "static/media/triangle.1d122f76.svg";